import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'elapsedTime',
    standalone: false
})
export class ElapsedTimePipe implements PipeTransform {
  transform(
    elapsedMs: number,
    format = '[d] days + [hh]h:[mm]m:[ss]s'
  ): string {
    if (!elapsedMs || elapsedMs < 0) {
      return '00h:00m:00s';
    }

    const INTERVALS_CONFIG = [
      { key: 'd', fullName: 'days', ms: 86400000 },
      { key: 'h', fullName: 'hours', ms: 3600000 },
      { key: 'm', fullName: 'minutes', ms: 60000 },
      { key: 's', fullName: 'seconds', ms: 1000 },
    ];

    let remaining = elapsedMs;
    let result = format;
    const subformats = format.match(/\[(.*?)\]/g) || [];

    for (const { key, fullName, ms } of INTERVALS_CONFIG) {
      const match = subformats.find(s => s.includes(key));
      if (!match) continue;

      const count = match.length - 2; // [hh] → 2 h's
      const value = Math.floor(remaining / ms);
      remaining -= value * ms;

      const padded = count > 1 && value < 10 ? '0' + value : '' + value;
      result = result.replace(match, padded);

      // Plural handling for full name units like "days"
      if (format.includes(fullName)) {
        result = result.replace(fullName, value === 1 ? fullName.slice(0, -1) : fullName);
      }
    }

    return result;
  }
}
